import { Container, Row, Col} from "react-bootstrap";
import ImageMessageBox from "../Images/ImageMessageBox.png"
import ImageSmartphone from "../Images/ImageSmartphone_600x481.png"
import ImageMessages from "../Images/ImageMessages_700x468.png"
import ImageWifi from "../Images/wifi.svg"
import PriceCard from "../components/PriceCard"
import Button from 'react-bootstrap/Button'

function MessageBox() {
    return (
        <Container fluid style={{backgroundColor: "#f4f6f7"}}>
            <Row style={{margin: "2% 5% 5% 5%", padding: "1.5% 0% 0% 0%", color: "#626567"}}>
                <Col>                                                        
                    <p style={{fontSize: "5vw", fontWeight: "bold"}}>
                        MessageBox        
                    </p>                   
                </Col>                
            </Row>

            <Row style={{margin: "5% 5% 0% 5%"}}>      
                <Col className="d-flex align-items-center" style={{padding: "5%", backgroundColor: "white", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2.5vw"}}> Bleiben Sie in Kontakt mit Ihren Liebsten</p>                    
                    <br/>                    
                </Col>          
                <Col style={{padding: "5%", backgroundColor: "white"}}>
                    <div className="row justify-content-center">                    
                        <PriceCard/>                    
                    </div>
                </Col>                                
            </Row>
       
            <Row style={{margin: "5% 5% 0% 5%"}}>                
                <Col style={{padding: "5%", backgroundColor: "#7ea4a5"}}>
                    <img src={ImageMessageBox} alt="MessageBox" className="img-fluid"></img>                    
                </Col>                
                <Col style={{padding: "5%", backgroundColor: "#afc7c7", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}> Die Nachrichten-Box für alle alleinlebenden Senorinnen und Senioren <br/><br/><br/>Benachrichtigen Sie Ihre Angehörigen, Freunde oder Betreuer durch<br/>einen einfachen Knopfdruck<br/><br/></p>                    
                    <p>                    
                        <Button variant="primary" style={{backgroundColor: "#6083bf", borderColor: "#6083bf", fontSize: "2.0vw"}} href='/howtouse'>mehr erfahren</Button>                
                    </p> 
                    <br/>                    
                </Col>
            </Row>        

            <Row style={{margin: "1px 5% 0% 5%"}}>                
                <Col style={{padding: "5%", backgroundColor: "#afc7c7", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>Lassen Sie Ihre Liebsten wissen wie es Ihnen geht<br/><br/>Die Nachrichten gehen direkt auf alle registrierten Smartphones<br/><br/></p>                                        
                    <p>                    
                        <Button variant="primary" style={{backgroundColor: "#6083bf", borderColor: "#6083bf", fontSize: "2.0vw"}} href='/telegram'>mehr erfahren</Button>                
                    </p> 
                </Col>
                <Col style={{padding: "5%", backgroundColor: "white"}}>
                    <img src={ImageSmartphone} alt="MessageBox" className="img-fluid"></img>                    
                </Col>                                
            </Row>        

            <Row style={{margin: "1px 5% 0% 5%"}}>                                
                <Col style={{padding: "5%", backgroundColor: "white"}}>
                    <img src={ImageMessages} alt="MessageBox" className="img-fluid"></img>                    
                </Col>                                
                <Col className="d-flex align-items-center justify-content-center" style={{padding: "5%", backgroundColor: "#afc7c7", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>Die Nachrichtentexte können von Ihnen beliebig verändert werden</p>
                </Col>
            </Row>    

            <Row style={{margin: "1px 5% 0% 5%"}}>                                
                <Col style={{padding: "5%", backgroundColor: "#afc7c7"}}>
                    <img src={ImageWifi} alt="MessageBox" className="img-fluid" style={{width: "30%"}}></img>                    
                </Col>                                
                <Col className="d-flex align-items-center justify-content-center" style={{padding: "5%", backgroundColor: "#7ea4a5", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>Technische Voraussetzung:<br /> WLAN <br /> mit Internetzugang</p>                    
                </Col>
            </Row>     

            <Row style={{margin: "1px 5% 0% 5%"}}>                                                
                <Col className="d-flex align-items-center justify-content-center" style={{padding: "2%", backgroundColor: "#afc7c7", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>keine laufenden Kosten: einmaliger Kaufpreis von 79€</p>                    
                </Col>
            </Row>     

            <Row style={{margin: "1px 5% 0% 5%"}}>                                                
                <Col className="d-flex align-items-center justify-content-center" style={{padding: "2%", backgroundColor: "#afc7c7", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>Kostenloser Installationsservice<br />im Raum Müllheim i. M.</p>                    
                </Col>
            </Row>     
            <Row style={{margin: "1px 5% 0% 5%"}}>                                                
                <Col className="d-flex align-items-center justify-content-center" style={{padding: "2%", backgroundColor: "#c7afc3", textAlign: "Center"}}>                    
                    <p style={{color: "#626567", fontSize: "2vw"}}>Melden Sie sich bei Interesse über unser Kontaktformular.<br />Wir würden uns freuen.</p>                    
                </Col>
            </Row>     
        </Container>
    )
}

export default MessageBox;